import { usePage } from '@inertiajs/react';
import { Box, Container, Grid, Group, Image, rem, Stack, Text, Title } from '@mantine/core';

import { MoneyFormatter } from '@/components/MoneyFormatter.jsx';

export default function Flexing(props) {
  const siteStats = usePage().props?.siteStats || {};

  return (
    <Container {...props}>
      <Group mt={'md'} justify={'space-around'} align={'center'}>
        <Box>
          <Text size={rem(30)} fw={300}>
            {siteStats.userCount}+
            <Text mt={4} size="sm" c="dimmed" fw={'bold'}>
              COLLECTORS
            </Text>
          </Text>
        </Box>
        <Box>
          <Text size={rem(30)} fw={300}>
            {siteStats.countries}+
            <Text mt={4} size="sm" c="dimmed" fw={'bold'}>
              COUNTRIES
            </Text>
          </Text>
        </Box>
        <Box>
          <Text size={rem(30)} fw={300}>
            <MoneyFormatter value={siteStats.totalValue} prefix="$" />
            <Text mt={4} size="sm" c="dimmed" fw={'bold'}>
              TOTAL ARTWORK VALUE
            </Text>
          </Text>
        </Box>
      </Group>
    </Container>
  );
}
